module.exports = __webpack_public_path__ + "media/images/faces/male/01-839263fe0cdc132ac4d4d9593e636209.jpg";